import VueRouter from 'vue-router';
import { Store } from 'vuex';
import { RootStoreState } from '@/store';

class AppInitService {
  initViewMode(router: VueRouter, store: Store<RootStoreState>) {
    router.onReady(() => {
      if (router.currentRoute.query.__vm__) {
        store.commit('setViewMode', { viewMode: router.currentRoute.query.__vm__ });
      }
      if (localStorage.getItem('code') !== undefined) {
        store.commit('setExchangeAccessCode', { exchangeAccessCode: localStorage.getItem('code') !== router.currentRoute.query.code });
      }
      if (router.currentRoute.query.code) {
        localStorage.setItem('code', `${router.currentRoute.query.code}`);
        store.commit('setCode', { code: router.currentRoute.query.code });
      }
      // if (router.currentRoute.query.token) {
      //   store.commit('setToken', { token: router.currentRoute.query.token });
      // }
      if (store.state && store.state.CoreStoreModule !== undefined && store.state.CoreStoreModule.tenantid === undefined) {
        store.commit('setTenantid', { tenantid: router.currentRoute.query.tenantid });
      }
      if (router.currentRoute.query.username) {
        store.commit('setUsername', { username: router.currentRoute.query.username });
      }
      if (router.currentRoute.query.cmx !== undefined && router.currentRoute.query.cmy !== undefined) {
        store.commit('setCircleMenuPos', {
          left: parseInt(router.currentRoute.query.cmx as string, 10),
          top: parseInt(router.currentRoute.query.cmy as string, 10),
        });
      }
    });
  }
}

export default new AppInitService();
